/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  Component,
  EventEmitter,
  Input,
  Output
} from '@angular/core';

@Component({
  selector: 'mega-store-factory-paginator',
  templateUrl: './paginator.component.html',
  styleUrls: ['./paginator.component.scss']
})
export class PaginatorComponent {
  @Input() recordsLength = 1;
  @Input() pageSize = 10;
  @Input() currentPage = 1;

  @Output() paginationOutput = new EventEmitter<any>();

  constructor() {
    // ToDo
  }

  handlePage(event: any) :void {
    const body = {
      pageSize: event.pageSize,
      currentPage: event.pageIndex + 1
    };

    this.paginationOutput.emit(body);
  }
}
